import React, {useEffect, useState} from 'react';
import {ReactComponent as Folder} from "../../assets/icons/direct.svg";
import {Spinner} from "@heroui/react";
import {getErrorMessage, toastError, toastSuccess} from "../../lib/toast";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {request} from "../../lib/request";
import {useUser} from "../../Providers/UserInfo";
import {buildProfilePayload, writeCachedProfile} from "../../lib/profileCache";

const Panel = ({open}) => {
    const queryClient = useQueryClient();
    const {
        is_open: activationEnabled,
        name,
        refetch,
    } = useUser();
    const [localActivation, setLocalActivation] = useState(activationEnabled);

    useEffect(() => {
        setLocalActivation(activationEnabled);
    }, [activationEnabled]);

    const {mutate, isPending} = useMutation({
        mutationFn: async () => await request({
            url: "/restaurant/panel/open",
            method: "post",
        }),
        onSuccess: (data) => {
            toastSuccess(data.message, {title: 'ثبت شد'});

            if (data?.data) {
                const payload = buildProfilePayload({
                    name,
                    is_open: data.data.is_open,
                    is_accepting_orders: data.data.is_accepting_orders,
                    within_working_hours: data.data.within_working_hours,
                });
                queryClient.setQueryData(['restProfile'], payload);
                writeCachedProfile(payload);
            }

            refetch();
        },
        onError: (err) => {
            setLocalActivation(activationEnabled ?? false);
            toastError(getErrorMessage(err));
        },
    });

    const change = () => {
        setLocalActivation((prev) => !prev);
        mutate();
    };

    const statusHint = localActivation ? 'فعال‌سازی روشن' : 'فعال‌سازی خاموش';
    const statusTone = localActivation ? 'open' : 'closed';

    if (!open) {
        return (
            <div className="rest-panel-nav__panel-icon center">
                <Folder/>
            </div>
        );
    }

    return (
        <div className="rest-panel-nav__panel-row">
            <div className="rest-panel-nav__panel-info">
                <Folder/>
                <div className="rest-panel-nav__panel-copy">
                    <p>فعال‌سازی رستوران</p>
                    <span
                        className={`rest-panel-nav__panel-hint rest-panel-nav__panel-hint--${statusTone}`}
                    >
                        {statusHint}
                    </span>
                </div>
            </div>
            {isPending ? (
                <Spinner size="sm" color="warning"/>
            ) : (
                <button
                    type="button"
                    role="switch"
                    aria-checked={!!localActivation}
                    aria-label={localActivation ? 'فعال‌سازی رستوران روشن است' : 'فعال‌سازی رستوران خاموش است'}
                    className={`rest-panel-toggle${localActivation ? ' rest-panel-toggle--on' : ''}`}
                    onClick={change}
                >
                    <span className="rest-panel-toggle__thumb" aria-hidden="true"/>
                </button>
            )}
        </div>
    );
};

export default Panel;
